import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as AuthActions from './auth.actions';
import * as fromAuth from './auth.reducers';
import * as AuthSelectors from './auth.selectors';
import { TokenResponse } from '@care-portals/api-interfaces';
import { filter } from 'rxjs/operators';

@Injectable()
export class AuthFacade {
  isAuthenticated$ = this.store.pipe(
    select(AuthSelectors.getIsAuth),
    filter(val => val !== null)
  );

  user$ = this.store.pipe(select(AuthSelectors.getUser));

  token$ = this.store.pipe(select(AuthSelectors.getToken));

  permissions$ = this.store.pipe(select(AuthSelectors.getPermissions));
  role$ = this.store.pipe(select(AuthSelectors.getRole));

  authState$ = this.store.pipe(select(AuthSelectors.getAuthState));

  whenUserReady$ = this.store
    .select(AuthSelectors.getUser)
    .pipe(filter(val => val !== null));

  constructor(private store: Store<fromAuth.AuthState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  validateAuth() {
    this.dispatch(AuthActions.validateAuth());
  }

  login(username: string, password: string) {
    this.store.dispatch(
      AuthActions.logIn({
        username,
        password
      })
    );
  }

  loadUser(token: TokenResponse | string) {
    if (typeof token === 'string') token = { token };
    this.store.dispatch(AuthActions.loadUser(token));
  }

  logOut() {
    this.store.dispatch(AuthActions.logOut());
  }

  resetPassword(password: string) {
    this.dispatch(AuthActions.resetPassword({ password }));
  }
}
